import React from 'react';
import { IconProps } from '.';

const SvgReset = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M20.75 12A8.75 8.75 0 0 0 5.202 6.49l-.196.26H8v1.5H2.25V2.5h1.5v3.424l.27-.358.008-.01A10.232 10.232 0 0 1 12 1.75c5.66 0 10.25 4.59 10.25 10.25S17.66 22.25 12 22.25c-5.276 0-9.62-3.986-10.187-9.112A10.355 10.355 0 0 1 1.75 12h1.5a8.751 8.751 0 0 0 17.5 0Z'
      />
    </svg>
  );
};

export default SvgReset;
